import { type FormManager } from "@kform/core";
import * as React from "react";

import { FormContext } from "../contexts/FormContext";
import { NoFormManagerError } from "../utils/errors";

/**
 * Hook providing access to the form manager within the context of a form. If a
 * form manager is provided as argument, then the provided argument is returned
 * instead.
 * @param formManager Optional argument which, when provided, is simply returned
 * as-is instead of the form manager within the context of a form.
 * @throws {NoFormManagerError} When no form manager was found.
 * @returns The form manager within the context of a form or, when provided, the
 * given form manager argument.
 */
export function useFormManager(formManager?: FormManager): FormManager {
  const formContext = React.useContext(FormContext);
  const relevantFormManager = formManager ?? formContext?.formManager;
  if (relevantFormManager == null) {
    throw new NoFormManagerError();
  }
  return relevantFormManager;
}
